<template>
  
 
 
  
  <v-app id="inspire" >
    
    <v-app-bar
      class="px-3"
      density="compact"
      height="76"
      elevation="1"
    >
    
    <v-progress-linear
    :active="layout.loading && (router.currentRoute.value.name=='report_search')"
    :indeterminate="layout.loading && (router.currentRoute.value.name=='report_search')"
    color="#EF4444"
    absolute
    bottom
  ></v-progress-linear>

    <template v-slot:prepend>

      <router-link to="/reportvalidation">
      <v-img
            alt="Insting BIB"
            contain
            :src="util.isMobile()?data.logoMobile:data.logo"
            transition="scale-transition"
            :width="util.isMobile()?'50px':'190px'"
            height="40px"
          />
      </router-link>
    </template>

      <v-tabs
        class="ins-tabs"
        selected-class="ins-selected-tabs"
        :hide-slider=data.hideSlider
        align-tabs="start"
      > 
        <div v-for="menu in layout.menus"
        :key="menu.id">
          <v-tab
            class="text-none"
            :text="menu.name"
            :to="menu.link"
          ></v-tab>
        </div>
        
      </v-tabs>
    

      <v-spacer></v-spacer>

      <!-- {{ auth.appData }} -->
    <v-avatar v-if="auth.appData">
      <v-img
        :src="(!auth.appData.photo || typeof auth.appData.photo !== 'string' || !auth.appData.photo.startsWith('http')) ? imgProfile : auth.appData.photo"
      >
          <template v-slot:error>
            <v-img :src="imgProfile"></v-img>
          </template>
      </v-img>
    </v-avatar>

    <v-btn-group class="inspire">
      <!-- <v-btn
        variant="flat">
        <div v-if="auth.appData" 
        @click="router.push('/profile')" 
        class="text-none font-weight-regular">
          Hai, {{ getFirstName()  }}
        </div>
      </v-btn> -->

      <v-btn
        width="120px"
        class="px-0"
        size="small"
        icon>
        Hai, {{ getFirstName()  }}
        <v-icon icon="mdi-menu-down"></v-icon>

        <v-menu
          activator="parent"
          location="bottom end"
          transition="fade-transition"
        >
          <v-list
            density="compact"
            min-width="150"
            rounded="lg"
            slim
          >
            <v-list-item
              prepend-icon="mdi-account-circle-outline"
              title="Lihat Profil"
              @click="router.push('/profile')"
            ></v-list-item>

            <v-list-item
              prepend-icon="mdi-logout-variant"
              title="Keluar"
              @click="doLogout"
            ></v-list-item>

          </v-list>
        </v-menu>
      </v-btn>
    </v-btn-group>

    </v-app-bar>
    
    <v-main :class="($route.name=='report_validation'||$route.name=='report_search'||$route.name=='monitor_hazard')?'app-main':'app-main-classic'">
      <RouterView />  
        
    </v-main>
  </v-app>
</template>

<script setup>

// import { filterStore } from "@/stores/filter";
import { useRouter } from "vue-router";
import Logo from "@/assets/logo.png";
import LogoInsting from "@/assets/logo_insting.png";
import imgProfile from "@/assets/default_profile.png";
import { onMounted, reactive ,inject } from "vue";
import { layoutStore } from "@/stores/layout";
import { authStore } from "@/stores/auth";
import insting from '@/assets/js/insting';
import { getKeycloak, removeKeycloack} from "../config/keycloak.js";
import util from '@/assets/js/util';

const router = useRouter();
// const filter = filterStore();
const layout = layoutStore();
// const axios = inject("axios");
const auth = authStore();

const axiosInsting = inject("axiosInsting");

const data = reactive({
  logo: Logo,
  logoMobile:LogoInsting,
  hideSlider:true
});

// function changeMenuType() {
//   switch (data.menuType) {
//     case "full":
//       data.menuType = "mini";
//       break;

//     case "mini":
//       data.menuType = "hide";
//       break;

//     default:
//       data.menuType = "full";
//   }
// }

async function logoutIam() {
  console.log("LOGOUT keycloak");
  
  try {
    const keycloak = getKeycloak(); // Fetch the Keycloak instance
    if (keycloak != null) {
        const token = localStorage.getItem("ugems-accessToken"); 
        const refreshToken = localStorage.getItem("ugems-refreshToken");

        result = await axiosInsting
                .post("auth/iam/logout", {
                  client_id: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
                  ugemsAccessToken: token,
                  ugemsRefreshToken: refreshToken,
                });

    } else {
      await router.push("/login");
    }
  } catch (error) {
    console.log("ERRROR LOGOUT keycloak",error);
    await router.push("/login");
  }
}

async function doLogout() {
    await logoutIam();
    auth.clear();
    localStorage.clear();
    window.location.reload(); 
}

function getFirstName(){
  if(auth.appData){
    var str = ""
    str = auth?.appData?.name ?? ""
    str = str.match(/^(\S+)\s(.*)/)?.slice(1)
    if(str != "" && str != null && str[0]){
      return str[0]
    }else{
      return ""
    }
  }
}

async function getProfile(){
  if(auth.appData){
    auth.appData.photo = await insting.getPhoto(axiosInsting,auth.appData?.isafe_no)
  }
}

onMounted(() => {
  getProfile()
});
</script>
<style scoped>
.app-main{
  background: #FAFAFA;
  background-image: url("@/assets/policy_top.png"), url("@/assets/policy_bottom.png");
  background-size: 383px 500px, 383px 500px;
  background-repeat: no-repeat, no-repeat;
  background-position:
    top left,
    bottom right;
}

.app-main-classic{
  background: #FAFAFA;
}
</style>